module.exports = __webpack_public_path__ + "static/media/id_front.b41f6aa9.png";